import { baseApi } from "..";
import { checkIsAdmin } from "../../../helpers/helpers";

// Define a service using a base URL and expected endpoints
export const prodOrderTemplate = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllProdOrderTemplates: builder.query({
      transformResponse: ({ data }) => data,
      queryFn: (args) => {
        console.log({ args });

        let templates = localStorage.getItem("parameters_prod_order_templates");

        if (templates === null)
          localStorage.setItem(
            "parameters_prod_order_templates",
            JSON.stringify([])
          );

        templates = localStorage.getItem("parameters_prod_order_templates");

        templates = JSON.parse(templates) || [];

        return {
          data: templates,
        };
      },
    }),

    createProdOrderTemplate: builder.mutation({
      queryFn: ({ name, productionOderCategories = [], trimDetails = [] }) => {
        let templates = localStorage.getItem("parameters_prod_order_templates");
        templates = JSON.parse(templates) || [];

        const newTemplate = {
          id: templates.length + 1,
          name,
          productionOderCategories,
          trimDetails,
        };

        const newTemplates = [...templates, newTemplate];

        localStorage.setItem(
          "parameters_prod_order_templates",
          JSON.stringify(newTemplates)
        );

        return {
          data: newTemplate,
        };
      },
      transformResponse: ({ data }) => data,
    }),

    editProdOrderTemplate: builder.mutation({
      transformResponse: ({ data }) => data,
      queryFn: ({
        id,
        name,
        productionOderCategories = [],
        trimDetails = [],
      }) => {
        let templates = localStorage.getItem("parameters_prod_order_templates");
        templates = JSON.parse(templates) || [];

        const newTemplates = templates.map((template) => {
          if (template.id === id) {
            return {
              ...template,
              name: name,
              productionOderCategories: productionOderCategories,
              trimDetails: trimDetails,
            };
          }
          return template;
        });

        localStorage.setItem(
          "parameters_prod_order_templates",
          JSON.stringify(newTemplates)
        );

        return {
          data: {
            id,
            name,
            productionOderCategories,
            trimDetails,
          },
        };
      },
    }),

    deleteProdOrderTemplate: builder.mutation({
      transformResponse: ({ data }) => data,
      queryFn: ({ id }) => {
        let templates = localStorage.getItem("parameters_prod_order_templates");
        templates = JSON.parse(templates) || [];

        const newTemplates = templates.filter((template) => template.id !== id);

        localStorage.setItem(
          "parameters_prod_order_templates",
          JSON.stringify(newTemplates)
        );
      },
    }),

    getProdTemplateById: builder.query({
      transformResponse: ({ data }) => data,
      queryFn: ({ id }) => {
        let templates = localStorage.getItem("parameters_prod_order_templates");
        templates = JSON.parse(templates) || [];

        return { data: templates.find((template) => template.id === id) };
      },
    }),
  }),

  overrideExisting: false,
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useCreateProdOrderTemplateMutation,
  useDeleteProdOrderTemplateMutation,
  useEditProdOrderTemplateMutation,
  useGetAllProdOrderTemplatesQuery,
  useGetProdTemplateByIdQuery,
  useLazyGetProdTemplateByIdQuery,
  useLazyGetAllProdOrderTemplatesQuery,
} = prodOrderTemplate;
